import { Card, CardContent } from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import { useStyles } from './styles';

type Props = {
  title: string;
  subtitle?: string;
  logo?: React.ReactNode;
  children?: React.ReactNode;
};

const PreferenceCard: React.FC<Props> = ({
  title,
  subtitle,
  logo,
  children,
}) => {
  const classes = useStyles();
  return (
    <Card>
      <CardContent className={classes.header}>
        {logo && (
          <Box mr={2} data-testid="preference-logo">
            {logo}
          </Box>
        )}
        <Box>
          <Typography variant="h4" data-testid="preference-title">
            {title}
          </Typography>
          {subtitle && (
            <Box mt={1}>
              <Typography
                className={classes.newFont}
                variant="body1"
                data-testid="preference-subtitle"
              >
                {subtitle}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
      <CardContent>
        <div data-testid="preference-content">{children}</div>
      </CardContent>
    </Card>
  );
};

export default memo(PreferenceCard);
